export default __webpack_public_path__ + "static/media/como-cadastrar-pagina2.1c7090ff.svg";